import React, { useEffect } from "react";
import { init } from "@socialgouv/matomo-next";
import { useCookieConsentContext } from "@use-cookie-consent/react";
import Script from "next/script";
// import Head from "next/head";
// import { Partytown } from "@builder.io/partytown/react";

const MATOMO_URL = process.env.NEXT_PUBLIC_MATOMO_URL;
const MATOMO_SITE_ID = process.env.NEXT_PUBLIC_MATOMO_SITE_ID;

const isDebug = process.env.NODE_ENV === "development";

const AnalyticsProvider: React.FC = () => {
  const {
    consent: { statistics },
  } = useCookieConsentContext();

  useEffect(() => {
    if (statistics) {
      // init({ url: MATOMO_URL, siteId: MATOMO_SITE_ID });
    }
  }, []);

  if (process.env.NODE_ENV === "development") {
    return null;
  }

  if (!statistics) return null;

  return (
    <>
      {/* <Head>
        <Partytown debug={isDebug} forward={["dataLayer.push"]} />
      </Head> */}
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=G-M7J38VC434"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', 'G-M7J38VC434');
        `}
      </Script>
      <Script strategy="afterInteractive" id="ms-analytics">
        {`
        (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
          })(window, document, "clarity", "script", "fhq0b1rsmy");
        `}
      </Script>
    </>
  );
};

export default AnalyticsProvider;
